/**
 *  @class
 *  @function ProductCompareTable
 */
if (!customElements.get('product-compare-table')) {
  class ProductCompareTable extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.container = this.querySelector('.compare-lightbox--data');
      this.addEventListeners();
    }

    addEventListeners() {
      this.addEventListener('render-product-compare-modal', this.renderTable.bind(this));
    }

    renderTable() {
      this.classList.add('loading');
      this.handles = this.getCompareHandles();
      this.fetchProducts();
    }

    getSelectedProducts() {
      return JSON.parse(window.localStorage.getItem('compare-products-vision')) || [];
    }

    getCompareHandles() {
      const { searchParams } = new URL(window.location);
      const handles = searchParams.get('compare');

      if (typeof handles === 'string' && handles !== '') {
        return handles.split(',');
      }

      return [];
    }

    async fetchProducts() {
      let compareProducts = this.getSelectedProducts(),
        returnHtml = '',
        returnArray = [];

      await Promise.all(compareProducts.map(async (product) => {
        await fetch(`${product.url}?view=compare`, {
          method: 'GET'
        }).then((response) => {
          return response.text();
        }).then((response) => {
          returnArray[product.id] = this.getSectionInnerHTML(response, '.compare-lightbox--data');
        });
      })).finally(() => {
        this.classList.remove('loading');
      });

      compareProducts.forEach((product, i) => {
        returnHtml += returnArray[product.id];
      });

      this.container.style.setProperty('--columns', compareProducts.length);
      this.container.innerHTML = returnHtml;

      this.equalHeights();
    }

    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    equalHeights() {
      for (let i = 0; i < 10; i++) {
        this.equalizeTableRowHeightAcrossTables(i);
      }
      this.hideEmptyRows();
    }

    hideEmptyRows() {
      const rows = this.container.querySelectorAll('.compare-lightbox--row');
      rows.forEach(row => {
        const isEmpty = row.textContent.trim() === '' && row.querySelectorAll('img, video, iframe, input, select, textarea, button').length === 0;
        row.style.display = isEmpty ? 'none' : '';
      });
    }

    equalizeTableRowHeightAcrossTables(rowPosition) {
      const tables = this.container.querySelectorAll('.compare-lightbox--table');
      const heights = [];

      tables.forEach(table => {
        const rows = table.querySelectorAll('.compare-lightbox--row');

        if (rows.length > rowPosition) {
          const rowHeight = rows[rowPosition].clientHeight;

          if (heights.length === 0) {
            heights[rowPosition] = rowHeight;
          } else {
            if (rowHeight > heights[rowPosition]) {
              heights[rowPosition] = rowHeight;
            }
          }
        }
      });

      tables.forEach(table => {
        const rows = table.querySelectorAll('.compare-lightbox--row');
        if (rows.length > rowPosition) {
          rows[rowPosition].style.height = heights[rowPosition] + 'px';
        }
      });
    }
  }

  customElements.define('product-compare-table', ProductCompareTable);
}
